export default angular
  .module("ModifyPhraseAliasCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("ModifyPhraseAliasController", [
    "$scope",
    "phrasealiasData",
    "$state",
    "$modalInstance",
    "$modal",
    "$stateParams",
    "$http",
    "$rootScope",
    "$translate",
    "Scripts",
    "System",
    function (
      $scope,
      phrasealiasData,
      $state,
      $modalInstance,
      $modal,
      $stateParams,
      $http,
      $rootScope,
      $translate,
      Scripts,
      System,
    ) {
      $scope.ok = function () {
        Scripts.updateScriptPhraseAliases($scope.phrasealiases, (data, status) => {
          if (status === 200) {
            $modalInstance.close();
          }
        });
      };
      $scope.cancel = function () {
        $modalInstance.dismiss("cancel");
      };
      $scope.phrasealiases = [];
      const { ALIAS_ID, ID, PHRASE_NAME } = phrasealiasData;

      Scripts.loadAllScriptPhraseAliasesByID(
        phrasealiasData.SCRIPT_ID,
        (phrases) => {
          const phraseMap = phrases
            .filter(p => p.ALIAS_ID === phrasealiasData.ALIAS_ID) // TODO: Backend filter?
            .reduce((map, p) => map.set(p.LANG, p), new Map());

          System.loadLanguages((languages) => {
            $scope.phrasealiases = languages.map(lang => ({
              ...(phraseMap.get(lang.ABBREVIATION) || {}),
              ALIAS_ID,
              ID,
              PHRASE_NAME,
              LANG: lang.ABBREVIATION,
              LANGUAGE_NAME: lang.NAME,
            }));
          });
        },
      );
    },
  ]);
